<template>

	<section id="Systems">

		<div id="Top">

			<div id="InTheLab">

				{{ $t('inTheLab') }}

			</div>

			<div id="Insp">

				{{ $t('inspectionMetrologyAnalysis') }}

			</div>

		</div>

		<div id="Bottom">

			<div id="InTheProd">

				{{ $t('productionLine') }}

			</div>

			<div id="Insp2">

				{{ $t('inspectionMetrology') }}

			</div>

		</div>

		<div class="tile tile--metrotom">

			<div class="tile__text">

				{{ $t('highPrecisionMetrologyIspection') }}

			</div>

			<img src="/image/xrayseries/systems/0.jpg" :alt="$t('highPrecisionMetrologyIspection')" />

		</div>

		<div class="tile tile--volumax">

			<img src="/image/xrayseries/systems/2.jpg" :alt="$t('fastAutomatedThreeDIspection')" />

			<div class="tile__text">

				{{ $t('fastAutomatedThreeDIspection') }}

			</div>

		</div>

		<div class="tile tile--xradia">

			<div class="tile__text">

				{{ $t('highResolutionAnalysisIspection') }}

			</div>

			<img src="/image/xrayseries/systems/1.jpg" :alt="$t('highResolutionAnalysisIspection')" />

		</div>

		<div class="tile tile--bosello">

			<img src="/image/xrayseries/systems/3.jpg" :alt="$t('fastAutomatedTwoDIspection')" />

			<div class="tile__text">

				{{ $t('fastAutomatedTwoDIspection') }}

			</div>

		</div>

		<div id="Menu">

			<img src="/image/menu.png" usemap="#menumap" alt="Menu" />

			<map name="menumap">

				<area @click="onClick('metrotom', 0)" shape="poly" coords="0,0,290,0,392,152,248,367" alt="Systems" />
				<area @click="onClick('xradia', 1)" shape="poly" coords="497,0,786,0,539,367,392,152" alt="Software" />
				<area @click="onClick('xraysystems', '/x-ray_series')" shape="poly" coords="392,152,539,367,392,582,248,367" alt="Applications" />
				<area @click="onClick('volumax', 2)" shape="poly" coords="248,367,392,582,290,734,0,734" alt="Services" />
				<area @click="onClick('bosello', 3)" shape="poly" coords="539,367,786,734,496,734,392,582" alt="Accessories" />

			</map>


			<div class="menu-el menu-el--metrotom">

				{{ $t('metrotom') }}

				<br />

				<div class="touch-effect" :class="{show: effect.metrotom}"></div>

			</div>

			<div class="menu-el menu-el--xradia">

				{{ $t('xradia') }}

				<br />

				<div class="touch-effect" :class="{show: effect.xradia}"></div>

			</div>


			<div class="menu-el menu-el--x-ray_systems">

				{{ $t('x-ray systems') }}

				<br />

				<div class="touch-effect" :class="{show: effect.xraysystems}"></div>

			</div>


			<div class="menu-el menu-el--volumax">

				{{ $t('volumax') }}

				<br />

				<div class="touch-effect" :class="{show: effect.volumax}"></div>

			</div>

			<div class="menu-el menu-el--bosello">

				{{ $t('bosello') }}

				<br />

				<div class="touch-effect" :class="{show: effect.bosello}"></div>

			</div>

		</div>

		<div v-if="popupShow" class="systems-popup">

			<div class="systems-popup__close">

				<img src="/image/close.png" alt="Close" @click="popupShow = false" />

			</div>

			<img :src="popupImage" alt="Popup" />

		</div>

	</section>

</template>

<script>

	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				popupShow: false,
				popupImage: null,
				effect: {
					metrotom: false,
					xradia: false,
					xraysystems: false,
					volumax: false,
					bosello: false
				}
			};
		},
		methods: {
			showPopup (number) {
				this.popupImage = this.$t('/image/xrayseries/systems/' + number + '.' + i18n.locale + '.png');
				this.popupShow = true;
			},
			onClick (element, href) {
				for (let k of Object.keys(this.effect)) {
					this.effect[k] = false;
				}

				this.effect[element] = true;

				setTimeout(() => {
					if (typeof href === 'number') {
						this.showPopup(href);
					}
					else {
						this.$router.push(href);
					}
				}, 750);
			}
		}
	};

</script>